/*!
 * Author:  Mark Allan B. Meriales
 * Name:    Mark Your Calendar v0.0.1
 * License: MIT License
 */
(function ($) {

    // Based on Gatineau (Quebec) Timezone (EDT/EST)
    Date.prototype.stdTimezoneOffset = function () {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    Date.prototype.isDstObserved = function () {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }

    Date.prototype.addHours = function (h) {
        this.setTime(this.getTime() + (h * 60 * 60 * 1000));
        return this;
    }

    // https://stackoverflow.com/questions/563406/add-days-to-javascript-date
    Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    };

    $.fn.markyourcalendar = function (opts, selectedTimeslot) {

        var prevHtml = "<span id=\"myc-prev-week\"><i class=\"icon-arrow-left\"></i></span>";
        var nextHtml = "<span id=\"myc-next-week\"><i class=\"icon-arrow-right\"></i></span>";
        var defaults = {
            availability: [[], [], [], [], [], [], []],
            // listahan ng mga oras na pwedeng piliin
            isMultiple: false,
            months: [globalLocalizer.getKey('Months.January'), globalLocalizer.getKey('Months.February'), globalLocalizer.getKey('Months.March'), globalLocalizer.getKey('Months.April'), globalLocalizer.getKey('Months.May'), globalLocalizer.getKey('Months.June'), globalLocalizer.getKey('Months.July'), globalLocalizer.getKey('Months.August'), globalLocalizer.getKey('Months.September'), globalLocalizer.getKey('Months.October'), globalLocalizer.getKey('Months.November'), globalLocalizer.getKey('Months.December')],
            prevHtml: prevHtml,
            nextHtml: nextHtml,
            selectedDates: [],
            startDate: opts.startDate,
            weekdays: [globalLocalizer.getKey('Days.Sunday'), globalLocalizer.getKey('Days.Monday'), globalLocalizer.getKey('Days.Tuesday'), globalLocalizer.getKey('Days.Wednesday'), globalLocalizer.getKey('Days.Thursday'), globalLocalizer.getKey('Days.Friday'), globalLocalizer.getKey('Days.Saturday')]
        };
        var settings = $.extend({}, defaults, opts);
        var html = "";
        var onClick = settings.onClick;
        var onClickNavigator = settings.onClickNavigator;
        var instance = this; // kuhanin ang buwan

        this.getMonthName = function (idx) {
            return settings.months[idx];
        };

        var formatDate = function (d) {
            var date = '' + d.getDate();
            var month = '' + (d.getMonth() + 1);
            var year = d.getFullYear();

            if (date.length < 2) {
                date = '0' + date;
            }

            if (month.length < 2) {
                month = '0' + month;
            }

            return year + '-' + month + '-' + date;
        }; // Eto ang controller para lumipat ng linggo
        // Controller to change


        this.getNavControl = function () {

            var disablePreviousWeekButton = '';
            var disableNextWeekButton = '';

            if (new Date() >= settings.startDate) {
                disablePreviousWeekButton = 'disabled';
            }

            var lastday = settings.startDate.addDays(6);

            if (lastday >= endDate) {
                disableNextWeekButton = 'disabled';
            }

            var previousWeekHtml = "<button id=\"myc-prev-week-container\" " + disablePreviousWeekButton + " class=\"btn btn-outline-light\">" + settings.prevHtml + "</button>";
            var nextWeekHtml = "<button id=\"myc-next-week-container\" " + disableNextWeekButton + " class=\"btn btn-outline-light\">" + settings.nextHtml + "</button>";

            var firstday = settings.startDate;//new Date(curr.setDate(curr.getDate() - curr.getDay()));
             //new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
            var to = globalLocalizer.getKey('Months.To');

            moment.locale(globalLocalizer.getCurrentIso2Lang());

            var monthYearHtml = "<input type=\"text\" readonly id=\"myc-current-month-year-container\" class=\"btn btn-outline-light js-datepicker\" value=\"" + moment(firstday).format('ll') + " " + to + " " + moment(lastday).format('ll') + "\" />";
            var navHtml = previousWeekHtml + monthYearHtml + nextWeekHtml;
            return navHtml;
        }; // kuhanin at ipakita ang mga araw

        this.getBackToProfileControl = function () {
            var backToProfile = "<a class=\"btn btn-link btn-sm px-0\" id=\"\backToProfileLink\" href=\"/AvailabilitySearch/Candidate?uid=" + uniqueId + "&sourceId=" + sourceId + "\">" +
                "<i class=\"icon-pen mr-3 font-size-lg\"></i><b>" + globalLocalizer.getKey('Links.Profile') + "</b></a>";
            return backToProfile;
        };

        this.getDatesHeader = function () {
            var tmp = "";
            var tmp2 = "";

            for (var i = 0; i < 7; i++) {
                var d = settings.startDate.addDays(i);
                tmp += "<th id=\"myc-date-header-" + i + "\"><div class=\"table-day-text\"><span class='d-none d-lg-inline'>" + settings.weekdays[d.getDay()] + "</span><span class='d-lg-none'>" + settings.weekdays[d.getDay()].substring(0, 3) + "</span></div></th> ";
                tmp2 += "<td class=\"table-day-number\" id=\"myc-date-header-" + i + "\">" + d.getDate() + "</td> ";
            }

            var ret = "<table id=\"myc-table-container\" class=\"booking-table booking-table-candidate table table-bordered\"><thead id=\"myc-dates-container\"><tr>" + tmp + "</tr><tr class=\"sub-header\">" + tmp2 + "</tr></thead>";
            return ret;
        }; // kuhanin ang mga pwedeng oras sa bawat araw ng kasalukuyang linggo


        this.getAvailableTimes = function () {
            var tmp = "";

            for (var i = 0; i < 7; i++) {
                var tmpAvailTimes = "<td>";

                var timeslotClassName;
                var disableSelectedTimeSlot;

                  $.each(settings.availability[i], function () {

                    if (selectedTimeslot == this.timeSlotId) {
                        timeslotClassName = 'btn btn-primary btn-block px-1 js-select-booking current-selection';
                        disableSelectedTimeSlot = ' disabled="disabled"';
                    }
                    else {
                        timeslotClassName = 'btn btn-primary btn-block px-1 js-select-booking';
                        disableSelectedTimeSlot = '';
                    }
                    tmpAvailTimes += "<button class=\"" + timeslotClassName + "\"" + disableSelectedTimeSlot + " data-slotid=\"" + this.timeSlotId + "\"  data-utc=\"" + this.timeSlotStartHourUtc + "\"  data-time=\"" + this.timeSlotStartHour + "\" data-date=\"" + formatDate(settings.startDate.addDays(i)) + "\">" + this.timeSlotStartHour + "<span class='range'> - </span>" + this.timeSlotEndHour + "</button>";
                    //timeslotClassName = 'myc-available-time';
                });
                tmp += "<div class=\"myc-day-time-container\" id=\"myc-day-time-container-" + i + "\">" + tmpAvailTimes + "</div></td>";
            }

            return tmp;
        }; // i-set ang mga oras na pwedeng ilaan


        this.setAvailability = function (arr) {
            settings.availability = arr;
            render();
        }; // clear


        this.clearAvailability = function () {
            settings.availability = [[], [], [], [], [], [], []];
        }; // pag napindot ang nakaraang linggo


        this.on('click', '#myc-prev-week-container', function () {

            settings.startDate = settings.startDate.addDays(-7);

            if (new Date() >= settings.startDate) {
                $("#myc-prev-week-container").prop("disabled", true);
            }
            else {
                $("#myc-prev-week-container").prop("disabled", false);
            }

            instance.clearAvailability();
            render(instance);

            if ($.isFunction(onClickNavigator)) {
                onClickNavigator.call(this, arguments[0], settings.startDate, instance);
            }
        }); // pag napindot ang susunod na linggo

        this.on('click', '#myc-next-week-container', function () {

            settings.startDate = settings.startDate.addDays(7);

            if (new Date() >= settings.startDate) {
                $("#myc-prev-week-container").prop("disabled", true);
            }
            else {
                $("#myc-prev-week-container").prop("disabled", false);
            }

            instance.clearAvailability();
            render(instance);

            if ($.isFunction(onClickNavigator)) {
                onClickNavigator.call(this, arguments[0], settings.startDate, instance);
            }
        }); // pag namili ng oras

        this.on('click', '.js-select-booking', function () {
            var date = $(this).data('date');
            var time = $(this).data('time');
            var utcDate = $(this).data('utc');
            var slotId = $(this).data('timeSlotId');
            var tmp = utcDate;

            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                var idx = settings.selectedDates.indexOf(tmp);

                if (idx !== -1) {
                    settings.selectedDates.splice(idx, 1);
                }
            } else {
                if (settings.isMultiple) {
                    $(this).addClass('selected');
                    settings.selectedDates.push(tmp);
                } else {
                    settings.selectedDates.pop();

                    if (!settings.selectedDates.length) {
                        $('.myc-available-time').removeClass('selected');
                        $(this).addClass('selected');
                        settings.selectedDates.push(tmp);
                    }
                }
            }

            if ($.isFunction(onClick)) {
                onClick.call(this, arguments[0], settings.StartDate, settings.selectedDates);
            }
        });

        var render = function () {
            var ret = "";

            ret += "<div id=\"myc-container\">";
            ret += "<div class=\"row mb-3\">";
            ret += "<div class=\"col-12 col-md-auto\"><div id=\"myc-nav-container\" class=\"week-picker btn-group btn-group-sm\">" + instance.getNavControl() + "</div></div>";
            ret += "<div class=\"col-auto ml-auto order-first order-md-last mb-3 mb-md-0\">" + instance.getBackToProfileControl() + "</div>";
            ret += "</div>";
            ret += "<div id=\"myc-week-container\">" + instance.getDatesHeader() + instance.getAvailableTimes() + "</div>";
            ret += "</div>";

            instance.html(ret);
        };

        render();
    };
})(jQuery);